<template>
  <div class="autocomplete">
    <input @click="openList()" @blur="closeList()" type="text" :value="value" class="fct-input" @input="onInput($event.target.value)"/>
    <v-bar v-show="isOpen && predictions.length > 0" class="scroll-area dropmenu-toggle" :settings="scrollSettings">
        <div v-for="(p, i) in predictions"
            class="autocomplete-result"
            :key="i"
            @mousedown="onSelect(p)">
          <span v-text="p"></span>
        </div>
    </v-bar>
  </div>
</template>

<script>
  import _ from 'lodash'
  import VBar from 'vue-perfect-scrollbar'

  export default {
      props: ['value', 'onInputChange'],
      components: {VBar},
      data() {
        return {
          scrollSettings: {},
          predictions: [],
          isOpen: false
        }
      },
      methods: {
        openList() {
          setTimeout(() => {
            this.isOpen = true
          }, 200)
        },
        closeList() {
          this.isOpen = false
        },
        onInput: _.debounce(function (text) {
          this.isOpen = true;
          this.$emit('input', text)
          return this.onInputChange(text)
            .then(predictions => {
              this.predictions = predictions
            })
        }, 250),
        onSelect (p) {
          this.$emit('input', p)
          this.closeList()
        }
      }
    }
</script>

<style lang="scss">

  //temp
  .autocomplete {
    .scroll-area.ps .ps__scrollbar-x-rail {
      display: none !important;
    }
  }
</style>

<style scoped lang="scss">
  @import "../../sass/fct/variables";
  .autocomplete {
    position: relative;
    width: 130px;
  }

  .scroll-area {
    max-height: 120px;
  }

  .dropmenu-toggle {
    z-index: 1000;
    position: absolute;
    /*right: 0;*/
    /*left: 0;*/
    display: block;
    top: 60px;
    padding-top: 10px;
    margin: 0;
    overflow-y: auto;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, .15);
    border-radius: 10px;
    text-align: left;
    list-style: none;
    background: #fff;
    width: 100%;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    /*max-height: 120px;*/
    width: 100%;
    overflow: auto;
    position: absolute;
    background-color: #fff;
    z-index: 1000;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);
    border-radius: 0 0 5px 5px;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    /*padding: 7px 19px 4px 19px;*/
    margin: 0 19px;
    cursor: pointer;
    overflow: hidden;
    font-family: montserratregular;

    > span {
      text-overflow: ellipsis;
      display: block;
      width: 100%;
      padding: 10px 0;
      clear: both;
      color: #414141; /* Overrides most CSS frameworks */
      white-space: nowrap;
      text-transform: capitalize;
      display: inline-block;
      -ms-transform: translateY(-9px);
      transform: translateY(-9px);
      color: $md-grey;
      font-size: 14px;
    }

    &:hover > span {
      cursor: pointer;
      color: $active-color;
      font-weight: bold;
    }

    &:not(:last-of-type) {
      > span {
        /*border-bottom: 1px solid #E2E2E2;*/
        background: linear-gradient(#E2E2E2, #E2E2E2) bottom /* left or right or else */
        no-repeat;
        background-size: 100% 1px;
      }
    }
  }
</style>
